import { cn } from '@/lib/utils';
import type { Recommendation } from '@/types';

const verbGlyph: Record<Recommendation['verb'], string> = {
  assist: '➜',
  insight: '◐',
  recommend: '✦',
  generate: '✎',
  research: '⌕',
};

/* A copilot recommendation as an actionable chip — advisory, human-gated.
 * Five verbs: assist · insight · recommend · generate · research (§5.2). */
export function RecommendationChip({
  rec,
  onReview,
  className,
}: {
  rec: Recommendation;
  onReview?: (rec: Recommendation) => void;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={() => onReview?.(rec)}
      className={cn(
        'group flex w-full items-start gap-2 rounded-md border border-ai/25 bg-ai-wash/40 px-3 py-2 text-left',
        'transition-colors duration-fast hover:border-ai/50 hover:bg-ai-wash/70',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ai',
        className,
      )}
    >
      <span className="mt-0.5 text-ai" aria-hidden>
        {verbGlyph[rec.verb]}
      </span>
      <span className="flex-1">
        <span className="block text-[10px] font-semibold uppercase tracking-wide text-ai">
          {rec.verb}
        </span>
        <span className="block text-sm text-text-primary">{rec.text}</span>
      </span>
      <span className="mt-0.5 text-[11px] text-text-tertiary opacity-0 transition-opacity group-hover:opacity-100">
        Review →
      </span>
    </button>
  );
}
